import { j as g } from "../../modules/index.es3.js";
import * as e from "react";
import { useImperativeHandle as M } from "react";
import { cn as P } from "../../utils/styling.es.js";
const k = () => e.useContext(S), S = e.createContext(null);
S.displayName = "WizardContext";
const W = e.forwardRef(
  ({
    header: m,
    footer: y,
    children: u,
    wrapper: a,
    className: z,
    startIndex: N = 0,
    loadingState: x,
    activeStepState: h,
    ...w
  }, C) => {
    const [r, i] = h || e.useState(N), [v, o] = x || e.useState(!1), c = e.useRef(!0), l = e.useRef(!1), n = e.useRef(() => {
    }), s = e.Children.toArray(u).length;
    c.current = r < s - 1, l.current = r > 0;
    const p = e.useRef(() => {
      c.current && i((t) => t + 1);
    }), R = e.useRef(() => {
      l.current && (n.current = null, i((t) => t - 1));
    }), d = e.useCallback(
      (t) => {
        t >= 0 && t < s && (n.current = null, i(t));
      },
      [s]
    ), j = e.useRef((t) => {
      n.current = t;
    }), A = e.useRef(async () => {
      if (c.current && n.current)
        try {
          o(!0), await n.current(), o(!1), n.current = null, p.current();
        } catch (t) {
          throw o(!1), t;
        }
      else
        p.current();
    }), T = e.useMemo(
      () => ({
        nextStep: A.current,
        previousStep: R.current,
        handleStep: j.current,
        isLoading: v,
        setIsLoading: o,
        activeStep: r,
        stepCount: s,
        isFirstStep: !l.current,
        isLastStep: !c.current,
        goToStep: d
      }),
      [v, r, s, d]
    );
    M(C, () => ({
      activeStep() {
        return r;
      },
      nextStep() {
        p.current();
      },
      previousStep() {
        R.current();
      },
      goToStep(t) {
        d(t);
      }
    }));
    const f = e.useMemo(() => e.Children.toArray(u)[r], [r, u]), L = e.useMemo(
      () => a ? e.cloneElement(a, {
        children: f
      }) : f,
      [a, f]
    );
    return /* @__PURE__ */ g.jsx("section", { ...w, className: P(z), ref: C, children: /* @__PURE__ */ g.jsxs(S.Provider, { value: T, children: [
      m,
      L,
      y
    ] }) });
  }
);
W.displayName = "Wizard";
export {
  W as Wizard,
  S as WizardContext,
  k as useWizard
};
//# sourceMappingURL=Wizard.es.js.map
